import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as LotActionType from "../constants";
import { Tab, Row, Col, Nav, NavItem } from "react-bootstrap";
import InputEditAble from "components/inputEditAble";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import ProjectDocumentSection from "Projects/Components/Document/homeowner-document-section";
import * as ProjectActionType from "../../Projects/constants";
import "../ho-doc.scss";

class HomeOwnerDocuments extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    HomeownerLots: PropTypes.array,
    homeownerLotSelectList: PropTypes.array,
    projectId: PropTypes.any,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      selectedLotId: null,
      documents: [],
      activeKey: "1",
      searchQuery: "",
      sortAscending: false,
      lotSortAscending: false,
      sortedLots: this.props.HomeownerLots ? this.props.HomeownerLots : null,
      lot: null,
      itemEdit: null,
      documentCategory: null,
      defaultLot: null,
      defaultLotFetched: false,
    };
  }

  componentDidMount() {
    this.fetchLot();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevLot = prevState.lot;
    const currentLot = this.state.lot;

    if (
      (!prevLot && currentLot) ||
      (prevLot && currentLot && prevLot.value !== currentLot.value)
    ) {
      this.fetchListDocumentType();
      this.setState({ activeKey: "0" });
    }

    if (
      prevState.documentCategory !== this.state.documentCategory &&
      this.state.documentCategory &&
      this.state.documentCategory.data &&
      this.state.documentCategory.data.length > 0 &&
      this.state.activeKey === "1"
    ) {
      this.setState({ activeKey: "0" });
    }

    // Handle lot selection when lots become available AND default lot is fetched
    if (
      this.props.homeownerLotSelectList.length > 0 &&
      !this.state.lot &&
      this.state.defaultLot !== null &&
      (prevProps.homeownerLotSelectList !== this.props.homeownerLotSelectList ||
        prevState.defaultLot !== this.state.defaultLot)
    ) {
      this.selectInitialLot();
    }
  }

  componentWillUnmount() {
    const input = document.querySelector(".tab-input input");
    if (input) {
      input.removeEventListener("keydown", this.handleInputKeyDown);
    }
  }

  onEditTabName = (item) => {
    this.setState(
      {
        itemEdit: item,
      },
      () => {
        setTimeout(() => {
          const input = document.querySelector(".tab-input input");
          if (input) {
            input.focus();
            input.select();
          }
        });
      }
    );
  };

  handleInputKeyDown = (e) => {
    if ([37, 38, 39, 40].includes(e.keyCode)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  // MODIFIED: Now sets a flag to indicate the API call is complete.
  fetchLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC,
    });
    this.props.dispatch({
      type: LotActionType.GET_DEFAULT_LOT,
      callback: (response) => {
        if (response && response.data && response.data.lotId) {
          this.setState({ defaultLot: response.data.lotId });
        } else {
          this.setState({ defaultLot: false });
        }
      },
    });
  };

  selectInitialLot = () => {
    const { homeownerLotSelectList } = this.props;
    const { defaultLot } = this.state;
    let lotToSelect = null;

    if (this.lotId) {
      lotToSelect = homeownerLotSelectList.find((l) => l.value === this.lotId);
      if (lotToSelect) {
        this.setState({ lot: lotToSelect });
        this.removeQueryParam && this.removeQueryParam("lotId");
        return;
      }
    }

    // Try to find default lot first
    if (defaultLot && defaultLot !== false) {
      lotToSelect = homeownerLotSelectList.find(
        (lot) => lot.value === defaultLot
      );
    }

    // If no default lot found, use first lot
    if (!lotToSelect && homeownerLotSelectList.length > 0) {
      lotToSelect = homeownerLotSelectList[0];
    }

    if (lotToSelect) {
      this.setState({ lot: lotToSelect });
    }
  };

  onSelectLot = (event) => {
    this.setState({
      lot: event.value,
      showModal: false,
      showEditModal: false,
      selectedDocument: null,
    });
  };

  onCancelEdit = () => {
    const input = document.querySelector(".tab-input input");
    if (input) {
      input.removeEventListener("keydown", this.handleInputKeyDown);
    }
    this.setState({
      itemEdit: null,
    });
  };

  // MODIFIED: Consolidated the two fetch functions and added safety checks
  fetchListDocumentType = () => {
    const { lot } = this.state;

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_DOCUMENT_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        lotId: lot.value,
      },
      callback: (data) => {
        const firstCategory = data && data.data ? data.data[0] : null;
        this.setState(
          {
            documentCategory: data,
            selectedCategory:
              firstCategory && firstCategory.value ? firstCategory.value : null,
          },
          () => {
            this.getDocumentByCategory(this.state.selectedCategory);
          }
        );
      },
    });
  };

  fetchListDocumentTypeFunc = () => {
    const { lot } = this.state;

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_DOCUMENT_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        lotId: lot.value,
      },
      callback: (data) => {
        this.setState(
          {
            documentCategory: data,
          },
          () => {
            this.getDocumentByCategory(this.state.selectedCategory);
          }
        );
      },
    });
  };

  onUpdateTabName = (param) => {
    const { lot, itemEdit } = this.state;

    // --- FIX: Add a guard clause ---
    if (!lot || !lot.extensionValue || !lot.extensionValue.builderProfile) {
      console.error("Cannot update tab name: lot or builderProfile is missing");
      return;
    }
    const { builderProfile } = lot.extensionValue;
    const params = {
      LotId: lot.value,
      CategoryName: param.name,
      CategoryId: itemEdit.value,
    };

    this.props.dispatch({
      type: ProjectActionType.UPDATE_HOMEOWNER_DOCUMENT_CATEGORY_TITLE_ASYNC,
      params: {
        url: builderProfile.builderHost,
        data: params,
        lotId: lot.value,
      },
      callback: (data) => {
        this.fetchListDocumentTypeFunc();
        this.onCancelEdit();
      },
    });
  };

  getDocumentByCategory = (categoryId) => {
    const { lot, selectedCategory } = this.state;
    const { builderProfile } = lot.extensionValue;

    const params = {
      CategoryId: selectedCategory,
      LotId: lot.value,
      SortBy: "FileName",
      SortOrder: false,
    };

    this.props.dispatch({
      type: LotActionType.GET_DOCUMENT_BY_CATEGORY_ASYNC,
      params: {
        url: builderProfile.builderHost,
        data: params,
        lotId: lot.value,
      },
      callback: (data) => {
        this.setState({ documents: data.data });
      },
    });
  };

  onSelectCategory = (event) => {
    const typeIndex = this.state.documentCategory.data.findIndex(
      (cat) => cat.value === event.value
    );
    this.setState(
      {
        selectedCategory: event.value,
        activeKey: typeIndex.toString(),
      },
      () => {
        this.getDocumentByCategory(event.value);
      }
    );
  };

  sortDocumentsByName = () => {
    const { sortAscending, documents } = this.state;
    if (!documents) return;

    const sortedDocuments = [...documents].sort((a, b) => {
      const nameA = a.fileName.toLowerCase();
      const nameB = b.fileName.toLowerCase();
      if (nameA < nameB) return sortAscending ? -1 : 1;
      if (nameA > nameB) return sortAscending ? 1 : -1;
      return 0;
    });

    this.setState({
      documents: sortedDocuments,
      sortAscending: !sortAscending,
    });
  };

  sortCategoryByName = () => {
    const { lotSortAscending, documentCategory } = this.state;
    if (!documentCategory || !documentCategory.data) return;

    const sortedCategoryData = [...documentCategory.data].sort((a, b) => {
      const nameA = a.text.toLowerCase();
      const nameB = b.text.toLowerCase();
      if (nameA < nameB) return lotSortAscending ? -1 : 1;
      if (nameA > nameB) return lotSortAscending ? 1 : -1;
      return 0;
    });

    this.setState((prevState) => ({
      documentCategory: {
        ...prevState.documentCategory,
        data: sortedCategoryData,
      },
      lotSortAscending: !prevState.lotSortAscending,
    }));
  };

  render() {
    const {
      activeKey,
      lot,
      itemEdit,
      documentCategory,
      documents,
      selectedCategory,
    } = this.state;
    const { homeownerLotSelectList } = this.props;
    const isDisabled = !Array.isArray(documents) || documents.length === 0;

    return (
      <div className="container-fluid app-container">
        <div
          className="project-document-wrapper homeowner-document"
          style={{ padding: 15 }}
        >
          <Tab.Container
            id="left-tabs-example"
            className="document-tab"
            activeKey={activeKey}
            onSelect={(key) => this.setState({ activeKey: key })}
          >
            <Row className="clearfix">
              <div>
                <Col sm={3} className="doc-category">
                  <div>
                    <label className="control-label">Filter by Property</label>
                    <div className="control-label">
                      <div className="select-lot">
                        <Dropdown
                          onChange={this.onSelectLot}
                          filter={true}
                          className="filestring-dropdown filter-dropdown"
                          options={homeownerLotSelectList}
                          optionLabel="text"
                          onRemote={this.fetchLot}
                          value={lot}
                          name="lot"
                          placeholder="-- Please select"
                          style={{
                            width: "21vw",
                            display: "inline-block",
                          }}
                        />
                      </div>
                    </div>
                    <div className="dropdown filter-dropdown">
                      <button
                        className="name-btn"
                        type="button"
                        data-toggle="dropdown"
                        onClick={this.sortCategoryByName}
                      >
                        Name{" "}
                        {this.state.lotSortAscending ? (
                          <i className="fa fa-angle-up" aria-hidden="true"></i>
                        ) : (
                          <i
                            className="fa fa-angle-down"
                            aria-hidden="true"
                          ></i>
                        )}
                      </button>
                    </div>
                  </div>
                  {lot && documentCategory && documentCategory.data ? (
                    <Nav bsStyle="pills" stacked>
                      {documentCategory.data.map((type, typeIndex) => {
                        const isEditing =
                          itemEdit && itemEdit.value === type.value;
                        const isActive = activeKey === typeIndex.toString();
                        return (
                          <React.Fragment key={type.value}>
                            {isEditing ? (
                              <div
                                style={{
                                  marginBottom: "30px",
                                  padding: "10px",
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "4px",
                                }}
                              >
                                <InputEditAble
                                  defaultValue={type.text}
                                  maxLength="60"
                                  inputName="name"
                                  className="tab-input"
                                  ignoreOnBlur={true}
                                  autoFocus
                                  onSubmit={this.onUpdateTabName}
                                  onCancel={this.onCancelEdit}
                                  onKeyDown={this.handleInputKeyDown}
                                  inputProps={{
                                    style: {
                                      width: "100%",
                                      padding: "8px",
                                      border: "1px solid #ddd",
                                      borderRadius: "4px",
                                    },
                                  }}
                                />
                              </div>
                            ) : (
                              <NavItem
                                eventKey={typeIndex.toString()}
                                onClick={() =>
                                  this.onSelectCategory({ value: type.value })
                                }
                                className={[
                                  isActive ? "active" : "",
                                  isEditing
                                    ? "document-nav-tab-edit"
                                    : "document-card",
                                ]
                                  .filter(Boolean)
                                  .join(" ")}
                                style={{
                                  pointerEvents: isEditing ? "none" : "auto",
                                  opacity: isEditing ? 0.7 : 1,
                                }}
                              >
                                <div className="document-card-content">
                                  <div className="left-section">
                                    <i
                                      className="fa fa-folder-o doc-icon"
                                      aria-hidden="true"
                                    ></i>
                                  </div>

                                  <div className="middle-section">
                                    <div className="doc-title">{type.text}</div>
                                    <div className="doc-subtitle">
                                      {type.documentCount} Docs
                                    </div>
                                  </div>

                                  <div className="right-section">
                                    <div className="btn-group">
                                      <button
                                        className="btn btn-default btn-sm dropdown-toggle"
                                        type="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      >
                                        <i
                                          className="fa fa-ellipsis-v menu-icon"
                                          aria-hidden="true"
                                        ></i>
                                      </button>
                                      <ul className="dropdown-menu">
                                        <li>
                                          <a
                                            onClick={(e) => {
                                              e.preventDefault();
                                              this.onEditTabName(type);
                                            }}
                                          >
                                            <span
                                              className="fa fa-pencil tab-title-edit-icon"
                                              style={{
                                                color: "#4a4a4a",
                                                marginRight: 5,
                                              }}
                                            />
                                            Edit category name
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </NavItem>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </Nav>
                  ) : (
                    lot && (
                      <p style={{ textAlign: "center", marginTop: "20px" }}>
                        No document categories found for this property.
                      </p>
                    )
                  )}
                </Col>
                <Col sm={9} className="doc-listing-section">
                  <div className="heading-div">
                    <div className="name-sort-btn">
                      <button
                        className="name-btn"
                        type="button"
                        data-toggle="dropdown"
                        disabled={isDisabled}
                        onClick={this.sortDocumentsByName}
                        style={
                          isDisabled
                            ? { opacity: 0.5, cursor: "not-allowed" }
                            : {}
                        }
                      >
                        Name
                        {this.state.sortAscending ? (
                          <i className="fa fa-angle-up" aria-hidden="true"></i>
                        ) : (
                          <i
                            className="fa fa-angle-down"
                            aria-hidden="true"
                          ></i>
                        )}
                      </button>
                    </div>

                    <div
                      className="search-container"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <i
                        className="fa fa-search"
                        style={{
                          position: "relative",
                          left: "30px",
                          pointerEvents: "none",
                          color: "rgb(159 155 155)",
                          fontSize: "16px",
                        }}
                        aria-hidden="true"
                      ></i>
                      <input
                        type="text"
                        placeholder="Search by Document"
                        className="search-input"
                        style={{
                          padding: "7px 14px 6px 35px",
                          borderRadius: "50px",
                          border: "1px solid #ccc",
                          width: "250px",
                        }}
                        value={this.state.searchQuery}
                        onChange={(e) =>
                          this.setState({ searchQuery: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <Tab.Content
                    animation
                    unmountOnExit={true}
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      backgroundColor: "#fff",
                      height: "50vh",
                    }}
                  >
                    {lot && documentCategory && documentCategory.data
                      ? documentCategory.data.map((type, index) => {
                          const filteredDocuments = (
                            this.state.documents || []
                          ).filter((doc) =>
                            doc.fileName
                              .toLowerCase()
                              .includes(this.state.searchQuery.toLowerCase())
                          );

                          return (
                            <Tab.Pane
                              eventKey={index.toString()}
                              key={index}
                              style={{ paddingTop: "0px" }}
                            >
                              <ProjectDocumentSection
                                hidden={activeKey !== index.toString()}
                                getDocumentByCategory={() =>
                                  this.getDocumentByCategory(selectedCategory)
                                }
                                fetchListDocumentType={
                                  this.fetchListDocumentTypeFunc
                                }
                                lot={lot}
                                documentTypeId={type.value}
                                documentType={type}
                                documents={filteredDocuments}
                              />
                            </Tab.Pane>
                          );
                        })
                      : ""}
                  </Tab.Content>
                </Col>
              </div>
            </Row>
          </Tab.Container>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    HomeownerLots: state.LotStore.HomeownerLots,
    homeownerLotSelectList: state.LotStore.HomeownerLotSelectList,
  };
};

export default connect(mapStateToProps)(HomeOwnerDocuments);



// WEBPACK FOOTER //
// ./src/Lots/Containers/homeowner-documents.js